import { Injectable } from '@angular/core';
import {AbstractDatabaseService} from "../../tandem-core/services/abstract-database.service";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {SpendingPlanChartMetadata} from "../models/spending-plan-chart-metadata";
import {CashFlowChartMetadata} from "../../cash-flows/models/cash-flow-chart-metadata";
import {Timestamp} from "firebase/firestore";

@Injectable({
  providedIn: 'root'
})
export class SpendingPlanChartMetadataService extends AbstractDatabaseService<SpendingPlanChartMetadata> {

  constructor(protected override afs: AngularFirestore) {
    super('spendingPlanChartMetadata', afs);
  }

  generateSampleChartData(userId: string): SpendingPlanChartMetadata {

    return {
      userId: '4xAYvEll38Rqbf88On5SPnzovpf1',
      charts: [
        {
          totalLifestyleExpenses: 1863.96,
          totalEssentialExpenses: 4907.84,
          totalRevenue: 21070,
          startDate: Timestamp.fromDate(new Date("2025-05-01")),
          endDate: Timestamp.fromDate(new Date("2025-05-31")),
          spendingPlanId: 'vlNx9wFSy5aK9FhhScuT',
          totalBusinessExpenses: 4330.52,
          netCashFlow: 6807.180000000002,
          totalPYFExpenses: 3160.5
        },
        {
          totalLifestyleExpenses: 463.96,
          spendingPlanId: 'q8AsjGQMIuVJhgTfBiD4',
          startDate: Timestamp.fromDate(new Date("2025-06-01")),
          endDate: Timestamp.fromDate(new Date("2025-06-30")),
          totalBusinessExpenses: 18380.52,
          totalPYFExpenses: 2253,
          totalEssentialExpenses: 4456.84,
          netCashFlow: -10534.320000000014,
          totalRevenue: 15020
        },
        {
          totalPYFExpenses: 6640.5,
          spendingPlanId: 'iSx6wWCH5FVZq23qjNPw',
          totalLifestyleExpenses: 5463.96,
          startDate: Timestamp.fromDate(new Date("2025-07-01")),
          endDate: Timestamp.fromDate(new Date("2025-07-31")),
          totalBusinessExpenses: 7834.68,
          totalRevenue: 44270,
          totalEssentialExpenses: 4897.84,
          netCashFlow: 19433.01999999999
        },
        {
          totalRevenue: 70270,
          totalBusinessExpenses: 8151.6,
          netCashFlow: 39964.419999999984,
          startDate: Timestamp.fromDate(new Date("2025-08-01")),
          endDate: Timestamp.fromDate(new Date("2025-08-31")),
          totalPYFExpenses: 10540.5,
          totalEssentialExpenses: 6357.84,
          totalLifestyleExpenses: 5255.64,
          spendingPlanId: 'MZ1YGXKiQPsElc6U8mYp'
        }
      ],
      dateCreated: Timestamp.now(),
      dateModified: Timestamp.now()
    }

    // return {
    //   userId: '4xAYvEll38Rqbf88On5SPnzovpf1',
    //   charts: [
    //     {
    //       spendingPlanId: 'vlNx9wFSy5aK9FhhScuT',
    //       startDate: Timestamp.fromDate(new Date("2025-08-01")),
    //       endDate: Timestamp.fromDate(new Date("2025-08-31")),
    //       netCashFlow: 6807.180000000002,
    //       totalRevenue: 21070,
    //       totalPYFExpenses: 3160.5,
    //       totalEssentialExpenses: 4907.84,
    //       totalLifestyleExpenses: 1863.96
    //     },
    //     {
    //       spendingPlanId: 'q8AsjGQMIuVJhgTfBiD4',
    //       startDate: Timestamp.fromDate(new Date("2025-08-01")),
    //       endDate: Timestamp.fromDate(new Date("2025-08-31")),
    //       netCashFlow: -10534.320000000014,
    //       totalRevenue: 15020,
    //       totalPYFExpenses: 2253,
    //       totalEssentialExpenses: 4456.84,
    //       totalLifestyleExpenses: 463.96
    //     },
    //     {
    //       spendingPlanId: 'iSx6wWCH5FVZq23qjNPw',
    //       startDate: Timestamp.fromDate(new Date("2025-08-01")),
    //       endDate: Timestamp.fromDate(new Date("2025-08-31")),
    //       netCashFlow: 19433.01999999999,
    //       totalRevenue: 44270,
    //       totalPYFExpenses: 6640.5,
    //       totalEssentialExpenses: 4897.84,
    //       totalLifestyleExpenses: 5463.96
    //     },
    //     {
    //       spendingPlanId: 'MZ1YGXKiQPsElc6U8mYp',
    //       startDate: Timestamp.fromDate(new Date("2025-08-01")),
    //       endDate: Timestamp.fromDate(new Date("2025-08-31")),
    //       netCashFlow: 39964.419999999984,
    //       totalRevenue: 70270,
    //       totalPYFExpenses: 10540.5,
    //       totalEssentialExpenses: 6357.84,
    //       totalLifestyleExpenses: 5255.64
    //     },
    //     {
    //       spendingPlanId: 'lXTAZNnS0exnvrekAuyX',
    //       startDate: Timestamp.fromDate(new Date("2025-08-01")),
    //       endDate: Timestamp.fromDate(new Date("2025-08-31")),
    //       netCashFlow: 8100,
    //       totalRevenue: 15000,
    //       totalPYFExpenses: 1500,
    //       totalEssentialExpenses: 750,
    //       totalLifestyleExpenses: 4500
    //     }
    //   ]
    // }

    let dates: Date[] = [];
    let currentDate = new Date();

    for (let i = 0; i < 7; i++) {
      // Add a copy of the current date to the array
      dates.push(new Date(currentDate.getTime()));

      // Subtract one month from the current date
      currentDate.setMonth(currentDate.getMonth() - 1);
    }
    return {
      userId: userId,
      dateCreated: Timestamp.now(),
      dateModified: Timestamp.now(),
      charts: [
        {
          spendingPlanId: '1',
          startDate: Timestamp.fromDate(dates[6]),
          endDate: Timestamp.fromDate(dates[5]),
          totalRevenue: 6500.00,
          totalPYFExpenses: 850.00,
          totalEssentialExpenses: 3200.00,
          totalLifestyleExpenses: 2000.00,
          netCashFlow: 450.00,
          totalBusinessExpenses: 0,
        },
        {
          spendingPlanId: '2',
          startDate: Timestamp.fromDate(dates[5]),
          endDate: Timestamp.fromDate(dates[4]),
          totalRevenue: 7000.00,
          totalPYFExpenses: 1000.00,
          totalEssentialExpenses: 3200.00,
          totalLifestyleExpenses: 2500.00,
          netCashFlow: 300.00,
          totalBusinessExpenses: 850.00,
        },
        {
          spendingPlanId: '3',
          startDate: Timestamp.fromDate(dates[4]),
          endDate: Timestamp.fromDate(dates[3]),
          totalRevenue: 8574.38,
          totalPYFExpenses: 1736.84,
          totalEssentialExpenses: 3200.00,
          totalLifestyleExpenses: 1250.00,
          netCashFlow: 2387.54,
          totalBusinessExpenses: 0,
        },
        {
          spendingPlanId: '4',
          startDate: Timestamp.fromDate(dates[3]),
          endDate: Timestamp.fromDate(dates[2]),
          totalRevenue: 7184.02,
          totalPYFExpenses: 1235.07,
          totalEssentialExpenses: 3200.00,
          totalLifestyleExpenses: 2500.00,
          netCashFlow: 248.95,
          totalBusinessExpenses: 850.00,
        },
        {
          spendingPlanId: '5',
          startDate: Timestamp.fromDate(dates[2]),
          endDate: Timestamp.fromDate(dates[1]),
          totalRevenue: 5864.15,
          totalPYFExpenses: 473.15,
          totalEssentialExpenses: 3200.00,
          totalLifestyleExpenses: 1250.00,
          netCashFlow: 941.00,
          totalBusinessExpenses: 0,
        },
        {
          spendingPlanId: '6',
          startDate: Timestamp.fromDate(dates[1]),
          endDate: Timestamp.fromDate(dates[0]),
          totalRevenue: 9748.35,
          totalPYFExpenses: 2674.05,
          totalEssentialExpenses: 3200.00,
          totalLifestyleExpenses: 3000.00,
          netCashFlow: 874.30,
          totalBusinessExpenses: 0,
        },
      ]
    }
  }
}
